
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { SnackBarService } from '../../../../cw-utils/cw-utils.module';
import { State } from '../../../models/tables/address/state';

@Injectable()
export class StateEditService implements Resolve<any>
{
    routeParams: any;
    onDataChanged: BehaviorSubject<any>;
    entity: State;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getState()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getState(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('state/' + this.routeParams.id).subscribe((res: State ) => {
                    this.entity = res;
                    this.onDataChanged.next(this.entity);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(state): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('state/', state).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(state): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('state/', state).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(state): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('state/' + state.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }
}
